/* Becquet Voiture : navigation « nouvelle ère » (octobre 2026).
   - Ordinateur (≥ 1100 px) : ouvre le panneau du méga-menu au survol (ou au focus clavier) d'un lien de
     premier niveau du menu Turbo (a.dropdown_link--vertical[data-dropdown-rel]) ; délai d'intention 110 ms,
     fermeture 260 ms après la sortie du lien ET du panneau ; Échap ferme. La meilleure vente de la marque
     est chargée à la première ouverture (/collections/<handle>/products.json).
   - Mobile et tablette (< 1100 px) : le bouton menu (en-tête mobile ou bouton « Menu » de la tablette) de l'en-tête ouvre le menu plein écran (capture sur window, avant le
     tiroir Turbo de bv-mobile-menu-fix). Onglets, fiches marque, Échap, retour, verrouillage du défilement.
   InstantClick (Turbo) remplace le body et rejoue ses scripts : l'état vit dans window.__bvnNavS, les
   écouteurs globaux ne sont posés qu'une fois, boot() relit le DOM de la page courante. */
(function () {
  'use strict';
  var S = window.__bvnNavS || (window.__bvnNavS = { panels: {}, m: null, current: null, link: null, openT: null, closeT: null, feats: {} });
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function each(l, f) { Array.prototype.forEach.call(l || [], f); }
  function money(c) { return (c / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' }); }
  function desktop() { return window.innerWidth >= 1100; }

  /* ---------- Méga-menu ---------- */
  function place(a) {
    var bar = a.closest('.main_nav_wrapper, .sticky_nav, .main_nav, header, #shopify-section-header') || a;
    var r = bar.getBoundingClientRect(), ra = a.getBoundingClientRect();
    document.documentElement.style.setProperty('--bvn-mega-top', Math.round(Math.max(r.bottom, ra.bottom + 6)) + 'px');
  }
  function show(rel, a) {
    var p = S.panels[rel];
    if (!p) return;
    clearTimeout(S.closeT);
    if (S.current && S.current !== p) hide(true);
    place(a);
    if (S.link && S.link !== a && S.link.parentNode) S.link.parentNode.classList.remove('bvn-on');
    S.link = a;
    a.parentNode.classList.add('bvn-on');
    a.setAttribute('aria-expanded', 'true');
    if (S.current === p) return;
    S.current = p;
    p.hidden = false;
    void p.offsetWidth;
    p.classList.add('is-open');
    feat(p);
  }
  function hide(now) {
    var p = S.current;
    if (!p) return;
    S.current = null;
    p.classList.remove('is-open');
    if (S.link) { if (S.link.parentNode) S.link.parentNode.classList.remove('bvn-on'); S.link.setAttribute('aria-expanded', 'false'); S.link = null; }
    if (now || reduce) p.hidden = true;
    else setTimeout(function () { if (!p.classList.contains('is-open')) p.hidden = true; }, 260);
  }
  function scheduleClose() {
    clearTimeout(S.openT); S.openT = null;
    clearTimeout(S.closeT);
    S.closeT = setTimeout(function () { hide(false); }, 260);
  }
  function linkOf(e) {
    var a = e.target && e.target.closest && e.target.closest('a.dropdown_link--vertical[data-dropdown-rel]');
    return a && S.panels[a.getAttribute('data-dropdown-rel')] ? a : null;
  }
  function feat(p) {
    var box = p.querySelector('[data-bvn-feat]'), h = p.getAttribute('data-col');
    if (!box || !h || S.feats[h] || box.querySelector('.bvn-feat:not(.bvn-feat--wait)')) return;
    S.feats[h] = true;
    fetch((window.Shopify&&Shopify.routes&&Shopify.routes.root||"/").replace(/\/$/,"") + '/collections/' + encodeURIComponent(h) + '/products.json?limit=8', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var wait = box.querySelector('.bvn-feat--wait');
        var prod = j && j.products && j.products.filter(function (x) {
          return x.images && x.images.length && x.variants && x.variants.some(function (v) { return v.available; });
        })[0];
        if (!prod) { box.style.display = 'none'; return; }
        var v = prod.variants.filter(function (x) { return x.available; })[0] || prod.variants[0];
        var price = Math.round(parseFloat(v.price) * 100), cmp = v.compare_at_price ? Math.round(parseFloat(v.compare_at_price) * 100) : 0;
        var src = prod.images[0].src;
        src += (src.indexOf('?') > -1 ? '&' : '?') + 'width=520';
        var a = document.createElement('a'); a.className = 'bvn-feat'; a.href = (window.Shopify&&Shopify.routes&&Shopify.routes.root||"/").replace(/\/$/,"") + '/products/' + prod.handle;
        var im = document.createElement('span'); im.className = 'bvn-feat__img';
        var img = document.createElement('img'); img.src = src; img.alt = prod.title; img.width = 260; img.height = 260; img.loading = 'lazy';
        im.appendChild(img);
        var b = document.createElement('span'); b.className = 'bvn-feat__b';
        var t = document.createElement('span'); t.className = 'bvn-feat__t'; t.textContent = prod.title;
        var pr = document.createElement('span'); pr.className = 'bvn-feat__p';
        var pb = document.createElement('b'); pb.textContent = money(price); pr.appendChild(pb);
        if (cmp > price) { var ps = document.createElement('s'); ps.textContent = money(cmp); pr.appendChild(ps); }
        var cta = document.createElement('span'); cta.className = 'bvn-feat__cta'; cta.textContent = (document.querySelector('[data-bvn-nav]') || document.body).getAttribute('data-see') || 'Voir le produit';
        b.appendChild(t); b.appendChild(pr); b.appendChild(cta);
        a.appendChild(im); a.appendChild(b);
        if (wait) wait.parentNode.replaceChild(a, wait); else box.appendChild(a);
      })
      .catch(function () { S.feats[h] = false; });
  }

  /* ---------- Menu mobile ---------- */
  function openM() {
    var m = S.m;
    if (!m) return;
    S.lastFocus = document.activeElement;
    m.hidden = false;
    void m.offsetWidth;
    m.classList.add('is-open');
    document.documentElement.classList.add('bvn-lock');
    var x = m.querySelector('[data-bvn-mnav-close]');
    if (x) setTimeout(function () { try { x.focus({ preventScroll: true }); } catch (e) {} }, 50);
  }
  function closeM() {
    var m = S.m;
    if (!m) return;
    m.classList.remove('is-open');
    document.documentElement.classList.remove('bvn-lock');
    each(m.querySelectorAll('.bvn-sheet.is-open'), function (s) { s.classList.remove('is-open'); s.hidden = true; });
    setTimeout(function () { if (!m.classList.contains('is-open')) m.hidden = true; }, reduce ? 0 : 320);
    if (S.lastFocus && S.lastFocus.focus) try { S.lastFocus.focus({ preventScroll: true }); } catch (e) {}
  }
  window.__bvnOpenMenu = openM;

  /* ---------- Écouteurs globaux (une seule fois) ---------- */
  if (!window.__bvnNavL) {
    window.__bvnNavL = true;
    document.documentElement.classList.add('bvn-mega-on');
    document.addEventListener('mouseover', function (e) {
      if (!desktop()) return;
      var a = linkOf(e);
      if (a) {
        clearTimeout(S.closeT);
        if (S.link === a) return;
        clearTimeout(S.openT);
        S.openT = setTimeout(function () { S.openT = null; show(a.getAttribute('data-dropdown-rel'), a); }, S.current ? 40 : 110);
        return;
      }
      if (S.current && S.current.contains(e.target)) { clearTimeout(S.closeT); return; }
      if (S.current || S.openT) scheduleClose();
    });
    document.addEventListener('focusin', function (e) {
      if (!desktop()) return;
      var a = linkOf(e);
      if (a) { show(a.getAttribute('data-dropdown-rel'), a); return; }
      if (S.current && !S.current.contains(e.target)) hide(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (S.current) { var a = S.link; hide(true); if (a) a.focus(); return; }
      var m = S.m;
      if (m && m.classList.contains('is-open')) {
        var s = m.querySelector('.bvn-sheet.is-open');
        if (s) { s.classList.remove('is-open'); setTimeout(function () { s.hidden = true; }, 300); } else closeM();
      }
    });
    window.addEventListener('scroll', function () { if (S.current && S.link) place(S.link); }, { passive: true });
    window.addEventListener('resize', function () { if (!desktop()) hide(true); });
    /* Bouton menu de l'en-tête mobile : capture sur window, donc avant le tiroir Turbo */
    window.addEventListener('click', function (e) {
      if (window.innerWidth >= 1100 || !S.m) return;
      var t = e.target && e.target.closest && e.target.closest('#header a.mobile_nav, a.mobile_nav[data-dropdown-rel="menu"], [data-bvn-open-menu]');
      if (!t) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (S.m.classList.contains('is-open')) closeM(); else openM();
    }, true);
  }

  function boot() {
    var nav = document.querySelector('[data-bvn-nav]');
    if (!nav || nav.__bvn) return;
    nav.__bvn = true;
    hide(true);
    /* panneaux de la page précédente (InstantClick) : on les retire */
    each(document.querySelectorAll('body > .bvn-mega, body > .bvn-mnav'), function (x) { if (!nav.contains(x)) x.parentNode.removeChild(x); });
    S.panels = {};
    each(nav.querySelectorAll('[data-bvn-mega]'), function (p) {
      S.panels[p.getAttribute('data-bvn-mega')] = p;
      document.body.appendChild(p); /* hors des conteneurs transformés de l'en-tête */
    });

    var m = nav.querySelector('[data-bvn-mnav]');
    S.m = m;
    if (!m) return;
    document.body.appendChild(m);
    document.documentElement.classList.remove('bvn-lock');
    m.querySelector('[data-bvn-mnav-close]').addEventListener('click', closeM);
    each(m.querySelectorAll('[data-bvn-tab]'), function (b) {
      b.addEventListener('click', function () {
        var k = b.getAttribute('data-bvn-tab');
        each(m.querySelectorAll('[data-bvn-tab]'), function (x) { var on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-selected', on ? 'true' : 'false'); });
        each(m.querySelectorAll('[data-bvn-pane]'), function (p) { p.classList.toggle('is-on', p.getAttribute('data-bvn-pane') === k); });
      });
    });
    each(m.querySelectorAll('[data-bvn-sheet]'), function (b) {
      b.addEventListener('click', function () {
        var s = document.getElementById(b.getAttribute('data-bvn-sheet'));
        if (!s) return;
        s.hidden = false;
        void s.offsetWidth;
        s.classList.add('is-open');
        var back = s.querySelector('[data-bvn-back]');
        if (back) setTimeout(function () { try { back.focus({ preventScroll: true }); } catch (e) {} }, 60);
      });
    });
    each(m.querySelectorAll('[data-bvn-back]'), function (b) {
      b.addEventListener('click', function () {
        var s = b.closest('.bvn-sheet');
        s.classList.remove('is-open');
        setTimeout(function () { s.hidden = true; }, reduce ? 0 : 300);
      });
    });
    /* Un lien suivi ferme le menu (InstantClick change de page sans recharger) */
    m.addEventListener('click', function (e) { var a = e.target.closest && e.target.closest('a[href]'); if (a) setTimeout(closeM, 60); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
